define([
	"dojo/_base/declare",
	"dojo/dom-style",
	"csi/gallery/Widget",
	"csi/xml"
], function(declare,domStyle,Widget,xml) {

	return declare(Widget, {
		_onLoadTemplate: function() {
			// summary: apply height to template
			this.inherited(arguments);

			var	sizeLabel = this.cacheView.getNode(this.getViewNode().SizeLabel);
			var	height = sizeLabel && sizeLabel.Height;
			if (height) {
				domStyle.set(this.blockNode.firstChild, "height", height + "cm");
			}
		}
	});
});